(function () {
  'use strict';

  var solicitationPattern = /\b(?:seo|search engine optimization|backlinks?|guest posts?|link building|lead generation|appointment setting|more (?:leads?|customers?|clients?|business)|grow your business|increase (?:sales|revenue)|advertising|marketing services?|web(?:site)? design|sponsored content|cold email(?:ing)?|social media management)\b/i;
  var initializedAt = Date.now();

  function field(form, selectors) {
    for (var i = 0; i < selectors.length; i += 1) {
      var element = form.querySelector(selectors[i]);
      if (element && typeof element.value === 'string') return element.value.trim();
    }
    return '';
  }

  function randomCaseToken(value) {
    var token = String(value || '').replace(/[^A-Za-z]/g, '');
    if (token.length < 16 || /\s/.test(value)) return false;
    var internalUppercase = (token.slice(1).match(/[A-Z]/g) || []).length;
    var transitions = 0;
    for (var i = 1; i < token.length; i += 1) {
      if (/[A-Z]/.test(token.charAt(i)) !== /[A-Z]/.test(token.charAt(i - 1))) transitions += 1;
    }
    return internalUppercase >= 2 && transitions >= 3;
  }

  function suspiciousEmail(email) {
    var local = String(email || '').toLowerCase().split('@')[0] || '';
    var segments = local.split('.').filter(Boolean);
    var shortSegments = segments.filter(function (segment) { return segment.length <= 2; }).length;
    return (segments.length >= 5 && shortSegments >= 3) ||
      (/^[a-z0-9]{22,}$/.test(local) && /[a-z]/.test(local) && /\d/.test(local)) ||
      randomCaseToken(local);
  }

  function shouldBlock(form) {
    var trap = field(form, ['[name="contact[website]"]']);
    if (trap) return true;

    var name = field(form, ['[name="contact[name]"]', '[name="name"]']);
    var email = field(form, ['[name="contact[email]"]', '[name="email"]']);
    var message = field(form, ['[name="contact[body]"]', '[name="message"]', 'textarea']);
    if (solicitationPattern.test(message)) return true;

    var risk = 0;
    if (randomCaseToken(name)) risk += 2;
    if (/^[A-Za-z0-9]{20,}$/.test(name) && !/\s/.test(name)) risk += 1;
    if (suspiciousEmail(email)) risk += 2;
    if (/^\S{20,}$/.test(message) && !/[.!?,;:]/.test(message)) risk += 2;
    if (Date.now() - initializedAt < 1800) risk += 1;
    return risk >= 2;
  }

  function showBlocked(form) {
    var status = form.querySelector('[data-form-guard-status]');
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-form-guard-status', '');
      status.setAttribute('role', 'alert');
      status.style.color = '#9b1c1c';
      status.style.fontWeight = '600';
      var submit = form.querySelector('[type="submit"]');
      if (submit && submit.parentNode) submit.parentNode.insertBefore(status, submit);
      else form.appendChild(status);
    }
    status.textContent = 'This form is reserved for engineering projects, technical recruiting, and engineering career inquiries. Advertising and unrelated sales submissions are not accepted.';
    status.scrollIntoView({ block: 'nearest' });
  }

  function inspect(event) {
    var target = event.target;
    var form = target && target.closest ? target.closest('form[action*="/contact"]') : null;
    if (!form || !shouldBlock(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showBlocked(form);
  }

  function prepare(form) {
    if (form.querySelector('[name="contact[website]"]')) return;
    var trap = document.createElement('input');
    trap.type = 'text';
    trap.name = 'contact[website]';
    trap.tabIndex = -1;
    trap.autocomplete = 'off';
    trap.setAttribute('aria-hidden', 'true');
    trap.style.position = 'absolute';
    trap.style.left = '-10000px';
    trap.style.width = '1px';
    trap.style.height = '1px';
    form.appendChild(trap);
  }

  document.querySelectorAll('form[action*="/contact"]').forEach(prepare);
  document.addEventListener('click', inspect, true);
  document.addEventListener('submit', inspect, true);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('form[action*="/contact"]').forEach(prepare);
  });
}());
